import React, { useEffect } from 'react';

import './App.css';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from './store/store';
import { getProfile } from './services/authServices';
import { authActions } from './store/reducers/authReducer';

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);


  useEffect(() => {

    const userProfile = async () => {

      const data = await getProfile();
      if (data && data.user) {
        if (!isAuthenticated) {
          dispatch(authActions.isAuthenticated(true));
        }
        dispatch(authActions.setUserProflie(data.user))
      }
    }

    userProfile();


  }, [dispatch, isAuthenticated])
  return (
    <RouterProvider router={router} />
  );
}

export default App;
